module.exports = __webpack_public_path__ + "img/enfp.2b52b19a.png";